var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { TemplateService } from "~/services/domain-service/template.service";
import { Emit, Prop } from "vue-property-decorator";
import { quillEditor } from 'vue-quill-editor';
import { KeyResource, EditorOption } from './letter-template.config';
var LetterTemplateConfig = /** @class */ (function (_super) {
    __extends(LetterTemplateConfig, _super);
    function LetterTemplateConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedKey = '';
        _this.keyResource = KeyResource;
        _this.editorOption = EditorOption;
        _this.content = '';
        _this.model = {
            templateCode: "",
            templateName: "",
            templateStatus: "ENABLED",
            templateContent: "",
            templateCategory: "CONTRACT",
            distributeType: "",
        };
        _this.rules = {
            templateCode: { required: true, message: "请输入模板编号" },
            templateName: { required: true, message: "请输入模板名称" },
            templateStatus: { required: true, message: '请选择模板状态' },
            distributeType: { required: true, message: '请选择适用部门' },
            templateContent: { required: true, message: '请输入合同模板内容' }
        };
        return _this;
    }
    LetterTemplateConfig.prototype.refresh = function () {
        if (!this.data) {
            var templateForm = this.$refs["form"];
            templateForm.resetFields();
            this.content = '';
            this.selectedKey = '';
        }
        else {
            this.selectedKey = '';
            this.formatContent(1);
            this.model.templateCode = this.data.templateCode;
            this.model.templateName = this.data.templateName;
            this.model.templateStatus = this.data.templateStatus;
            this.model.isDefault = this.data.isDefault;
            this.model.distributeType = this.data.distributeType;
        }
    };
    LetterTemplateConfig.prototype.refreshData = function () { };
    LetterTemplateConfig.prototype.close = function () { };
    /**
     * 提交新建模板按钮
     */
    LetterTemplateConfig.prototype.commit = function (type) {
        var _this = this;
        var templateForm = this.$refs["form"];
        templateForm.validate(function (validate) {
            if (!validate)
                return;
            if (!_this.formatContent(0))
                return;
            var params = __assign({}, _this.model);
            if (_this.data) {
                params.id = _this.data.id;
            }
            _this.templateService.createTemplate(params).subscribe(function () {
                _this.refreshData();
                _this.close();
                _this.$message.success('操作成功');
            });
        });
    };
    /**
     * 插入选中的参数到富文本光标所在之处
     */
    LetterTemplateConfig.prototype.insertToTextArea = function () {
        if (this.selectedKey === '') {
            return;
        }
        var editor = this.$refs['editor'];
        var quill = editor.quill;
        quill.focus();
        var selection = quill.getSelection();
        var insertKey = '[' + this.selectedKey + ']';
        if (selection.length > 0) {
            // 如果是选中模式需要先删除原有数据
            quill.deleteText(selection.index, selection.length);
        }
        quill.insertText(selection.index, insertKey);
        quill.setSelection(selection.index + insertKey.length, 0);
    };
    LetterTemplateConfig.prototype.formatContent = function (mode) {
        var message = '';
        var regex = '';
        if (mode === 0) {
            if (!this.content) {
                this.$message.error('请编辑模板内容');
                return false;
            }
            message = this.content;
            this.keyResource.map(function (obj) {
                // 0 替换为Value
                regex = new RegExp('\\[\\' + obj.name + '?\\]', 'g');
                message = message.replace(regex, obj.value);
            });
            // 先替换\t
            regex = new RegExp('\\t{1}', 'g');
            message = message.replace(regex, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
            // 然后替换\s [空格]
            regex = new RegExp('\\s{2}?', 'g');
            message = message.replace(regex, '&nbsp;&nbsp;');
            this.model.templateContent = message;
        }
        else {
            if (this.data.templateContent) {
                message = this.data.templateContent;
                // 1 替换为name
                this.keyResource.map(function (obj) {
                    regex = new RegExp('\\' + obj.value + '?', 'g');
                    message = message.replace(regex, '[' + obj.name + ']');
                });
                this.content = message;
            }
            else {
                this.model.templateContent = '';
                this.content = '';
            }
        }
        return true;
    };
    __decorate([
        Dependencies(TemplateService)
    ], LetterTemplateConfig.prototype, "templateService", void 0);
    __decorate([
        Prop()
    ], LetterTemplateConfig.prototype, "data", void 0);
    __decorate([
        Emit('refreshData')
    ], LetterTemplateConfig.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], LetterTemplateConfig.prototype, "close", null);
    LetterTemplateConfig = __decorate([
        Component({
            components: {
                quillEditor: quillEditor
            }
        })
    ], LetterTemplateConfig);
    return LetterTemplateConfig;
}(Vue));
export default LetterTemplateConfig;
